"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var AccountsListAdmin_module_css_1 = __importDefault(require("./AccountsListAdmin.module.css"));
var IntegrationServerHelper_1 = __importDefault(require("@/Helper/IntegrationServerHelper"));
var PusherService_1 = __importDefault(require("@/functions/PusherService"));
var IntegrationServerListView = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)([]), serverList = _a[0], setServerList = _a[1];
    (0, react_1.useEffect)(function () {
        var loadServers = function () { return __awaiter(void 0, void 0, void 0, function () {
            var list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, IntegrationServerHelper_1.default.getList()];
                    case 1:
                        list = _a.sent();
                        setServerList(list);
                        return [2 /*return*/];
                }
            });
        }); };
        loadServers();
    }, []);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h1", { className: "ns-font-family-bold ".concat(AccountsListAdmin_module_css_1.default["header-text"]) }, t("Integration servers")),
        react_1.default.createElement("div", null, serverList.map(function (server) {
            return (react_1.default.createElement(IntegrationServerCard, { key: server.id, server: server }));
        }))));
};
var FormattedDateTime = function (props) {
    return props.date
        ? (react_1.default.createElement(react_1.default.Fragment, null,
            props.date.getDate()
                + "/" + (props.date.getMonth() + 1)
                + "-" + props.date.getFullYear(),
            react_1.default.createElement("sup", { style: { marginLeft: ".25em" } }, ("0" + props.date.getHours()).slice(-2)
                + ":" + ("0" + props.date.getMinutes()).slice(-2))))
        : (react_1.default.createElement(react_1.default.Fragment, null, "N/A"));
};
var FormattedTime = function (props) {
    var _a;
    var time = (_a = props.seconds) !== null && _a !== void 0 ? _a : 0;
    if (time > 60) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { style: { marginRight: ".5em" } },
                Math.floor(time / 60),
                react_1.default.createElement("sup", { style: { marginLeft: ".25em" } }, "min"))));
    }
    else {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { style: { marginRight: ".5em" } },
                time,
                react_1.default.createElement("sup", { style: { marginLeft: ".25em" } }, "sec"))));
    }
};
var addSeconds = function (date, seconds) {
    if (!date)
        return undefined;
    var newDate = new Date(date.getTime());
    newDate.setSeconds(date.getSeconds() + seconds);
    return newDate;
};
var IntegrationServerCard = function (props) {
    var _a, _b, _c, _d;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _e = (0, react_1.useState)(undefined), serverState = _e[0], setServerState = _e[1];
    var _f = (0, react_1.useState)(undefined), serverStats = _f[0], setServerStats = _f[1];
    var fetchServerInfo = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var state;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, IntegrationServerHelper_1.default.getState(id)];
                case 1:
                    state = _a.sent();
                    setServerState(state);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchServerStats = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var stats;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, IntegrationServerHelper_1.default.getStats(id)];
                case 1:
                    stats = _a.sent();
                    setServerStats(stats);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        PusherService_1.default.bind("server", "event", function (data) {
            if (data.id === props.server.identifier) {
                switch (data.message) {
                    case "worker-started":
                    case "worker-active":
                    case "worker-inactive":
                    case "worker-exited":
                        fetchServerInfo(data.id);
                        break;
                    case "stats-updated":
                        fetchServerStats(data.id);
                        break;
                }
            }
        });
        fetchServerInfo(props.server.identifier);
        fetchServerStats(props.server.identifier);
    }, []);
    var latestHour = undefined;
    var latestDay = undefined;
    var latestMonth = undefined;
    if (serverStats) {
        latestHour = Object.keys(serverStats.h).sort().pop();
        latestDay = Object.keys(serverStats.d).sort().pop();
        latestMonth = Object.keys(serverStats.m).sort().pop();
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { marginBottom: "20px" } },
            react_1.default.createElement("div", { style: { border: "1px solid #ccc", borderRadius: "4px", padding: "10px 15px", marginBottom: "2px", marginTop: "10px", backgroundColor: "var(--secondary-color)" } }, props.server.name),
            react_1.default.createElement("div", { style: { border: "1px solid #ccc", borderRadius: "4px", padding: "10px 15px", marginBottom: "2px", marginTop: "2px" } },
                react_1.default.createElement("div", { style: { display: "flex", flexWrap: "wrap" } },
                    react_1.default.createElement("div", { style: { width: "35%" } },
                        react_1.default.createElement("dl", null,
                            react_1.default.createElement("dt", null,
                                t("Server id"),
                                ":"),
                            react_1.default.createElement("dd", null, props.server.id),
                            react_1.default.createElement("dt", null,
                                t("Name"),
                                ":"),
                            react_1.default.createElement("dd", null, String(props.server.name)),
                            react_1.default.createElement("dt", null,
                                t("No. workers"),
                                ":"),
                            react_1.default.createElement("dd", null,
                                react_1.default.createElement("span", { style: { marginRight: ".5em" } }, (_a = serverState === null || serverState === void 0 ? void 0 : serverState.workers_running) !== null && _a !== void 0 ? _a : "n/a",
                                    react_1.default.createElement("sup", { style: { marginLeft: ".25em" } }, "running")),
                                react_1.default.createElement("span", { style: { marginRight: ".5em" } },
                                    serverState ? (serverState.workers_running) - ((_b = serverState === null || serverState === void 0 ? void 0 : serverState.workers_active) !== null && _b !== void 0 ? _b : 0) : "n/a",
                                    react_1.default.createElement("sup", { style: { marginLeft: ".25em" } }, "ready")),
                                react_1.default.createElement("span", { style: { marginRight: ".5em" } }, (_c = serverState === null || serverState === void 0 ? void 0 : serverState.workers_active) !== null && _c !== void 0 ? _c : "n/a",
                                    react_1.default.createElement("sup", { style: { marginLeft: ".25em" } }, "active")),
                                react_1.default.createElement("span", { style: { marginRight: ".5em" } }, (_d = serverState === null || serverState === void 0 ? void 0 : serverState.workers_max) !== null && _d !== void 0 ? _d : "n/a",
                                    react_1.default.createElement("sup", { style: { marginLeft: ".25em" } }, "total"))))),
                    react_1.default.createElement("div", { style: { width: "35%" } },
                        react_1.default.createElement("dl", null,
                            react_1.default.createElement("dt", null,
                                t("No. integrations"),
                                ":"),
                            react_1.default.createElement("dd", null,
                                react_1.default.createElement("span", { style: { marginRight: ".5em" } },
                                    serverStats ? serverStats.no_integrations : "n/a",
                                    react_1.default.createElement("sup", { style: { marginLeft: ".25em" } }, "integrations")),
                                react_1.default.createElement("span", { style: { marginRight: ".5em" } },
                                    serverStats ? serverStats.no_scripts : "n/a",
                                    react_1.default.createElement("sup", { style: { marginLeft: ".25em" } }, "scripts"))),
                            react_1.default.createElement("dt", null,
                                t("No. job runs"),
                                ":"),
                            react_1.default.createElement("dd", null,
                                react_1.default.createElement("span", { style: { marginRight: ".5em" } },
                                    latestHour ? serverStats.h[latestHour].count : "n/a",
                                    react_1.default.createElement("sup", { style: { marginLeft: ".25em" } }, "this hour")),
                                react_1.default.createElement("span", { style: { marginRight: ".5em" } },
                                    latestDay ? serverStats.d[latestDay].count : "n/a",
                                    react_1.default.createElement("sup", { style: { marginLeft: ".25em" } }, "today")),
                                react_1.default.createElement("span", { style: { marginRight: ".5em" } },
                                    latestMonth ? serverStats.m[latestMonth].count : "n/a",
                                    react_1.default.createElement("sup", { style: { marginLeft: ".25em" } }, "this month"))))),
                    react_1.default.createElement("div", { style: { width: "30%" } },
                        react_1.default.createElement("dl", null,
                            react_1.default.createElement("dt", null,
                                t("Heatbeat freq"),
                                ":"),
                            react_1.default.createElement("dd", null,
                                react_1.default.createElement(FormattedTime, { seconds: props.server.expected_heartbeat_freq })),
                            react_1.default.createElement("dt", null,
                                t("First heatbeat"),
                                ":"),
                            react_1.default.createElement("dd", null,
                                react_1.default.createElement(FormattedDateTime, { date: props.server.first_heartbeat_at })),
                            react_1.default.createElement("dt", null,
                                t("Latest heatbeat"),
                                ":"),
                            react_1.default.createElement("dd", null,
                                react_1.default.createElement(FormattedDateTime, { date: props.server.last_heartbeat_at })),
                            react_1.default.createElement("dt", null,
                                t("Next heatbeat"),
                                ":"),
                            react_1.default.createElement("dd", null,
                                react_1.default.createElement(FormattedDateTime, { date: addSeconds(props.server.last_heartbeat_at, props.server.expected_heartbeat_freq) })))))))));
};
exports.default = IntegrationServerListView;
